export default "__VITE_ASSET__e6df5286__"